
import { defineComponent, ref, reactive } from 'vue';
export default defineComponent({
  name: 'Online',
  setup() {
    const dialog = ref([
      { text: "你好，很高兴为您服务(〃'▽'〃)！", type: 'from' },
      { text: '请问有什么可以帮您的呢?', type: 'from' },
    ]);
    const context = ref('');
    const consult = () => {
      dialog.value.push({
        text: context.value,
        type: 'to',
      });
      context.value = '';
      dialog.value.push({
        text: '很抱歉！当前客服不在线，请稍后再试或电话咨询。',
        type: 'from',
      });
    };
    return {
      dialog,
      context,
      consult,
    };
  },
});
